import React, {useContext} from 'react'
import { AppBar, Toolbar, IconButton, Typography, Stack } from '@mui/material'
import logo from '../../assets/logo-no-bg.png'
import { Context } from '../../App';
import AccountMenu from '../ui/AccountMenu';

export default function Header(props) {
    const { setIsConnected } = useContext(Context)

    function handleLogout() {
        sessionStorage.clear()
        setIsConnected(false)
    }

    return(
        <AppBar position='sticky' sx={{height:'60px'}}>
            <Toolbar>

                <Stack direction='row' spacing={0.5} sx={{ alignItems: 'center', mr: 4, cursor: 'pointer', '&:hover': {opacity: 0.8} }} onClick={() => window.location.href = '/'}>
                    <img src={logo} style={{ width: '50px'}}/>
                    <Typography variant='body1' fontWeight={500} color='grey'>Admin</Typography>
                </Stack>
                
                <AccountMenu />

            </Toolbar>
        </AppBar>
    )
}